import { combineReducers } from 'redux'
import activityReducer from './activity'
import configManagementReducer from './configManagement'
import historyReducer from './history'

export default combineReducers({
  activity: activityReducer,
  history: historyReducer,
  configManagement: configManagementReducer,
})
